import React from 'react';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';

import Text from '../common/Text';
import Picture from '../image/CloudFrontPicture';
import InternalLink from '../InternalLink';

const CurrentHashtagWinner = () => {
    const StyledCurrentHashtagWinner = styled.div`
        &.schnoffle-hashtag-winner img {
          max-heigth: 60vh;
          max-width: 60vw;
        }

        & .schnoffle-hashtag-winner-text {
          margin-bottom: 2em;
        }
    `;

    return (
        <StyledCurrentHashtagWinner className='schnoffle-hashtag-winner'>
            <Text.Heading
                text='Unsere Gewinner'
                level={3}
            />
            <Text.Heading
                text='Gewinnerin Juni 2019'
                level={3}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'mia',
                        patternid: 22485,
                    },
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }}
            >
                <Picture
                    src='hashtag-springschnoffle.jpg'
                    webp='hashtag-springschnoffle.webp' schnoffle
                />
            </InternalLink>
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 24472,
                        },
                        meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'martha' },
                }}
            >
                "Martha"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.facebook.com/FarbTuepfelchen/posts/2410162472546984'
            >Carina aka Kleines Farb - Tupferl</a>,
                gewinnt die Junirunde
                des #schnoffle Hashtag Wettbewerbs #springschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 24472,
                    },
                    meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } },
                }}
            >
                <Picture
                    src='schnoffle-gewinner-q2-19.png'
                    webp='sschnoffle-gewinner-q2-19.webp' png schnoffle
                />
            </InternalLink>

            <Text.Divider/>
            <Text.Heading
                text='März 2019'
                level={3}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 22084,
                    },
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }}
            >
                <Picture
                    src='2019-01-60erschnoffle.png'
                    webp='2019-01-60erschnoffle.webp' png schnoffle
                />
            </InternalLink>
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'edda',
                            patternid: 23378,
                        },
                        meta: { query: { colors: '1c8c80,8d2e98,fccdd1' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'edda' },
                }}
            >
                "EDDA"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.instagram.com/p/Bt3o9SFHl38/'
            >Marietta</a>,
                gewinnt die Märzrunde
                des #schnoffle Hashtag Wettbewerbs #6oerschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'edda',
                        patternid: 23378,
                    },
                    meta: { query: { colors: '1c8c80,8d2e98,fccdd1' } },
                }}
            >
                <Picture
                    src='schnoffle-gewinner-q1-19.png'
                    webp='sschnoffle-gewinner-q1-19.webp' png schnoffle
                />
            </InternalLink>

                <Text.Divider/>
            <Text.Heading
                text='Dezember 2018'
                level={3}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: { sewpatId: 'pony', patternid: 20404 },
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }}
            >
                <Picture
                    src='dezember-blackandwhiteschnoffle.png'
                    webp='dezember-blackandwhiteschnoffle' png schnoffle
                />
            </InternalLink>
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'pony',
                            patternid: 20404,
                        },
                        meta: { query: { colors: 'ffffff,000000' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'pony' },
                }}
            >
                "Pony"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.pinterest.de/pin/815010863793088838/'
            >Andrea Albrecht</a>,
                gewinnt die Dezemberrunde
                des #schnoffle Hashtag Wettbewerbs #blackandwhiteschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'pony',
                        patternid: 20404,
                    },
                    meta: { query: { colors: 'ffffff,000000' } },
                }}
            >
                <Picture
                    src='schnoffle-winner-12-18.png'
                    webp='sschnoffle-winner-12-18.webp' png schnoffle
                />
            </InternalLink>
            <Text.Divider/>

            <Text.Heading
                text='November 2018'
                level={3}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: { sewpatId: 'martha', patternid: 824 },
                    meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }}
            >
                <Picture
                    src='november-adventschnoffle.png'
                    webp='november-adventschnoffle' png schnoffle
                />
            </InternalLink>
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'liv',
                            patternid: 2549,
                        },
                        meta: { query: { colors: '111314,5e4d33,ffffff' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'liv' },
                }}
            >
                "Liv"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.facebook.com/FarbTuepfelchen/photos/a.1739331306296774/2263861993843700/'
            >Carina We (Kleines FarbTupferl)</a>,
                gewinnt die Novemberrunde
                des #schnoffle Hashtag Wettbewerbs #adventschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 2549,
                    },
                    meta: { query: { colors: '111314,5e4d33,ffffff' } },
                }}
            >
                <Picture
                    src='schnoffle-winner-11-18.png'
                    webp='sschnoffle-winner-11-18.webp' png schnoffle
                />
            </InternalLink>
            <Text.Divider/>
            <Text.Heading
                text='Oktober 2018'
                level={3}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'paula',
                        patternid: 4643,
                    },
                }}
            >
                <Picture
                    src='oktober-forestschnoffle.png'
                    webp='oktober-forestschnoffle' png schnoffle
                />
            </InternalLink>
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'lilly',
                            patternid: 20625,
                        },
                        meta: { query: { colors: '6d7e46,cf905c,e6e4cc,2e1804' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'lilly' },
                }}
            >
                "Lilly"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.pinterest.de/pin/815010863792282930/'
            >Andrea Albrecht</a>,
                gewinnt die Oktoberrunde
                des #schnoffle Hashtag Wettbewerbs #forestschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'lilly',
                        patternid: 20625,
                    },
                    meta: { query: { colors: '6d7e46,cf905c,e6e4cc,2e1804' } },
                }}
            >
                <Picture
                    src='schnoffle-winner-10-18.png'
                    webp='sschnoffle-winner-10-18.webp' png schnoffle
                />
            </InternalLink>
            <Text.Divider/>
            <Text.Heading
                text='September 2018'
                level={5}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'lina',
                        patternid: 3489,
                    },
                }}
            >
                <Picture
                    src='september-paisleyschnoffle.png'
                    webp='september-paisleychnoffle' png schnoffle
                />
            </InternalLink>

            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 3489,
                        },
                        meta: { query: { colors: 'a993bd,523171,8841ca,8c65b1,3c294e,5c4c6b,ba9fd4,28222d,6e5387,8a6da5,985cd2,9c7bbc,ac8fc7' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'martha' },
                }}
            >
                "Martha"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.pinterest.com/pin/580401470704790154/'
            >Birgit Elmrich</a>,
                gewinnt die Septemberrunde
                des #schnoffle Hashtag Wettbewerbs #paisleyschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 3489,
                    },
                    meta: { query: { colors: 'a993bd,523171,8841ca,8c65b1,3c294e,5c4c6b,ba9fd4,28222d,6e5387,8a6da5,985cd2,9c7bbc,ac8fc7' } },
                }}
            >
                <Picture
                    src='schnoffle-winner-09-18.png'
                    webp='schnoffle-winner-09-18' png schnoffle
                />
            </InternalLink>
            <Text.Divider/>
            <Text.Heading
                text='August 2018'
                level={5}
            />
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 17499,
                    },
                }}
            >
                <Picture
                    src='august-betaschnoffle.png'
                    webp='august-betaschnoffle' png schnoffle
                />
            </InternalLink>

            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'liv',
                            patternid: 10882,
                        },
                        meta: { query: { colors: '6e2d40,181818,Cc7a2ab,ffffff,000000' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SEWPAT_VIEW,
                    payload: { sewpatId: 'liv' },
                }}
            >
                "Liv"&nbsp;
            </InternalLink>
                eingereicht von <a
                href=' https://www.instagram.com/p/BmnNJ7hDQhe/'
            >ebomil</a>,
                gewinnt die Augustrunde
                des #schnoffle Hashtag Wettbewerbs #betaschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 10882,
                    },
                    meta: { query: { colors: '6e2d40,181818,Cc7a2ab,ffffff,000000' } },
                }}
            >
                <Picture
                    src='schnoffle-winner-0.png'
                    webp='schnoffle-winner-0' png schnoffle
                />
            </InternalLink>
        </StyledCurrentHashtagWinner>
    );
};

export default CurrentHashtagWinner;



// WEBPACK FOOTER //
// ./src/components/hashtag/HashtagWinnerHistory.js